import { useState } from 'react'
import type { Website } from '../types'

type WebsiteScrapingProps = {
  websites: Website[]
  loading: boolean
  onAddWebsite: (url: string) => void
  onDeleteWebsite: (websiteId: string) => void
  onStartScraping: () => void
}

export function WebsiteScraping({
  websites,
  loading,
  onAddWebsite,
  onDeleteWebsite,
  onStartScraping,
}: WebsiteScrapingProps) {
  const [newWebsiteUrl, setNewWebsiteUrl] = useState('')

  function handleAdd() {
    if (!newWebsiteUrl.trim()) return
    onAddWebsite(newWebsiteUrl.trim())
    setNewWebsiteUrl('')
  }

  return (
    <div className="card p-6 mb-6">
      <h2 className="text-lg font-semibold text-theme-primary mb-4">Website Scraping</h2>

      <div className="flex space-x-2 mb-4">
        <input
          type="url"
          value={newWebsiteUrl}
          onChange={(e) => setNewWebsiteUrl(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && handleAdd()}
          placeholder="https://example.com"
          className="input flex-1"
        />
        <button onClick={handleAdd} className="btn-success">
          Add URL
        </button>
      </div>

      <div className="space-y-2 mb-4">
        {websites.map((website) => (
          <div
            key={website.id}
            className="flex items-center justify-between p-3 bg-surface-elevated rounded-md"
          >
            <span className="text-sm text-theme-primary truncate mr-2">{website.url}</span>
            <button
              onClick={() => onDeleteWebsite(website.id)}
              className="btn-danger btn-sm shrink-0"
            >
              Delete
            </button>
          </div>
        ))}
        {websites.length === 0 && (
          <p className="text-theme-muted text-sm">No websites added yet</p>
        )}
      </div>

      <button
        onClick={onStartScraping}
        disabled={loading || websites.length === 0}
        className="btn-primary disabled:opacity-50"
      >
        {loading ? 'Starting...' : 'Start Scraping'}
      </button>
    </div>
  )
}
